/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NoticeDto } from '../../models/notice-dto';

export interface NoticeControllerTogglePinned$Params {
  id: string;
}

export function noticeControllerTogglePinned(http: HttpClient, rootUrl: string, params: NoticeControllerTogglePinned$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
  const rb = new RequestBuilder(rootUrl, noticeControllerTogglePinned.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NoticeDto>;
    })
  );
}

noticeControllerTogglePinned.PATH = '/api/notices/{id}/toggle-pinned';
